import { Grid, Stack } from '@mui/material';

import { AppMode } from '@/modules/common/types/general';
import NotificationPopup from '@/modules/Notifications/components/NotificationPopup';
import { ValidationPanel } from '@/modules/floorplanV2/components/ValidationPanel';

import { CenterMenu } from './CenterMenu';
import { Logo } from './Logo';
import { Title } from './Title';
import { UserMenu } from './UserMenu';

export const BUILDER_BAR_HEIGHT = 48;

export function BuilderBar() {
  return (
    <Grid container spacing={2} alignItems='center' data-testid='BuilderBar'>
      <Grid item xs={4}>
        <Stack direction='row' alignItems='center'>
          <Logo />
        </Stack>
      </Grid>
      <Grid item xs={4} style={{ textAlign: 'center' }}>
        <Stack direction='row' justifyContent='center' alignItems='center'>
          <Title />
          <CenterMenu />
        </Stack>
      </Grid>
      <Grid item xs={4}>
        <Stack direction='row' justifyContent='flex-end' alignItems='center' spacing={2}>
          <ValidationPanel />
          <NotificationPopup />
          <UserMenu appMode={AppMode.DigitalTwin} />
        </Stack>
      </Grid>
    </Grid>
  );
}
